export const ko = {
  // Common
  "common.back": "뒤로",
  "common.cancel": "취소",
  "common.noItems": "항목 없음",
  "common.loading": "로딩 중...",
  
  // Header
  "nav.features": "기능",
  "nav.howItWorks": "작동 방식",
  "nav.pricing": "요금제",
  "nav.faq": "자주 묻는 질문",
  "nav.testimonials": "쇼케이스",
  "nav.contact": "문의",
  "button.getStarted": "시작하기",
  "button.loading": "로딩 중...",
  
  // Auth related
  "auth.signIn": "로그인",
  "auth.redirecting": "리디렉션 중...",
  "auth.continueWithGoogle": "Google로 계속하기",
  "auth.continueWithGithub": "GitHub로 계속하기",
  "auth.or": "또는",
  "auth.consent.prefix": "계속함으로써 귀하는 당사의",
  "auth.consent.terms": "이용 약관",
  "auth.consent.and": "및",
  "auth.consent.privacy": "개인정보 처리방침",
  
  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "통화제승",
  
  // Hero Section
  "hero.title": "AI 기반 커뮤니케이션 어시스턴트",
  "hero.subtitle": "지능적이고 상황에 맞는 응답으로 대화를 변화시켜 어떤 상황에서도 더 효과적으로 소통할 수 있도록 도와줍니다.",
  "hero.cta.primary": "무료 체험 시작",
  "hero.cta.secondary": "데모 보기",
  
  // Main Title
  "main.title": "모든 답변을 기회로 바꾸세요",
  
  // Footer Section
  "footer.company": "회사",
  "footer.product": "제품",
  "footer.support": "지원",
  "footer.legal": "법적 사항",
  "footer.contactSupport": "지원팀 연락",
  "footer.helpCenter": "도움말 센터",
  "footer.apiDocs": "API 문서",
  "footer.statusPage": "상태 페이지",
  "footer.privacyPolicy": "개인정보 처리방침",
  "footer.termsOfService": "서비스 약관",
  "footer.cookiePolicy": "쿠키 정책",
  "footer.refundPolicy": "환불 정책",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "지원",
  
  // Features Section
  "features.badge": "강력한 기능",
  "features.title": "더 나은 커뮤니케이션을 위한 모든 것",
  "features.subtitle": "모든 대화를 더 효과적이고 전문적으로 만들기 위해 설계된 포괄적인 도구.",
  "features.scenario.title": "시나리오 템플릿",
  "features.scenario.description": "직장, 개인, 학술 및 전문 커뮤니케이션을 위한 사전 구축된 템플릿.",
  "features.custom.title": "사용자 정의 입력",
  "features.custom.description": "메시지나 콘텐츠를 붙여넣고 상황에 맞는 적절한 응답을 받으세요.",
  "features.instant.title": "답변 시간 90% 단축",
  "features.instant.description": "몇 초 만에 AI가 작성한 답변을 받으세요. 기다림 없이, 결과만.",
  "features.copy.title": "원클릭 복사 및 공유",
  "features.copy.description": "응답을 즉시 복사하거나 플랫폼에서 직접 공유하세요.",
  
  // How It Works Section
  "howItWorks.badge": "작동 방식",
  "howItWorks.title": "더 나은 커뮤니케이션을 위한 3가지 간단한 단계",
  "howItWorks.subtitle": "우리의 간소화된 프로세스로 어떤 상황에서도 전문적인 응답을 쉽게 생성할 수 있습니다.",
  "howItWorks.step1.title": "시나리오 선택",
  "howItWorks.step1.description": "귀하의 필요에 가장 적합한 커뮤니케이션 시나리오를 선택하세요.",
  "howItWorks.step2.title": "콘텐츠 붙여넣기",
  "howItWorks.step2.description": "응답해야 할 메시지나 콘텐츠를 추가하세요.",
  "howItWorks.step3.title": "AI 응답 받기",
  "howItWorks.step3.description": "몇 초 만에 전문적이고 상황에 맞는 응답을 받으세요.",
  
  // Pricing Section
  "pricing.title": "요금제",
  "pricing.subtitle": "커뮤니케이션 요구에 맞는 플랜을 선택하세요",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/월",
  "pricing.free.description": "서비스를 체험해보기에 완벽함",
  "pricing.pro.description": "전문가와 자주 사용하는 사용자에게 이상적",
  "pricing.business.description": "팀과 조직을 위한",
  "pricing.popular": "가장 인기",
  "pricing.free.feature1": "월 10회 답변",
  "pricing.free.feature2": "기본 시나리오",
  "pricing.free.feature3": "템플릿 정의 및 사용",
  "pricing.free.feature4": "과거 답변 기록",
  "pricing.pro.feature1": "월 200회 답변",
  "pricing.pro.feature2": "기본+사용자 정의 시나리오",
  "pricing.pro.feature3": "템플릿 정의 및 사용",
  "pricing.pro.feature4": "과거 답변 기록",
  "pricing.pro.feature5": "고급 사용자 정의",
  "pricing.business.feature1": "무제한 답변",
  "pricing.business.feature2": "팀 협업",
  "pricing.business.feature3": "기본+사용자 정의 시나리오",
  "pricing.business.feature4": "템플릿 정의 및 사용",
  "pricing.business.feature5": "과거 답변 기록",
  "pricing.business.feature6": "고급 사용자 정의",
  "pricing.cta.trial": "무료 체험 시작",
  "pricing.cta.subscribe": "구독하기",
  "pricing.cta.contact": "영업팀 연락",
  "pricing.cta.current": "현재 플랜",
  "pricing.currentPlan": "현재 플랜:",
  "pricing.endDate": "현재 플랜 종료일:",
  "pricing.autoRenewalDate": "현재 플랜 자동 갱신일:",
  "pricing.answersLeft": "남은 답변 수:",
  "pricing.planName.free": "Free 플랜",
  "pricing.planName.proMonthly": "Pro 플랜-월간",
  "pricing.planName.proYearly": "Pro 플랜-연간",
  "pricing.planName.maxMonthly": "Enterprise 플랜-월간",
  "pricing.planName.maxYearly": "Enterprise 플랜-연간",
  "pricing.autoRenews": "답변 수 자동 갱신일:",
  "pricing.needMore": "더 많은 답변이 필요하신가요?",
  "pricing.upgradeBelow": "아래에서 플랜을 업그레이드하세요",
  "pricing.doNotRollOver": "사용하지 않은 답변은 이월되지 않습니다",
  "pricing.willCancelOn": "취소 예정일:",
  "pricing.downgradeScheduled": "다운그레이드 예정. 다음으로 변경됩니다",
  "pricing.on": "일자:",
  "pricing.upgradeImmediateTitle": "플랜 업그레이드됨",
  "pricing.upgradeImmediateDesc": "새로운 플랜이 이제 활성화되었습니다.",
  "pricing.downgradeScheduledTitle": "다운그레이드 예정",
  "pricing.downgradeScheduledDesc": "다음 갱신 시 플랜이 변경됩니다.",
  "pricing.cancelScheduledTitle": "취소 예정",
  "pricing.cancelScheduledDesc": "플랜은 기간 종료 시 종료됩니다.",
  "pricing.cancelResumedTitle": "취소 제거됨",
  "pricing.cancelResumedDesc": "구독이 계속 갱신됩니다.",
  "pricing.cancelPendingDowngrade": "취소",
  "pricing.pendingDowngradeCanceledTitle": "보류 중인 다운그레이드 취소됨",
  "pricing.pendingDowngradeCanceledDesc": "플랜이 변경되지 않습니다.",
  "pricing.pendingDowngradeCancelFailedTitle": "취소 실패",
  "pricing.pendingDowngradeCancelFailedDesc": "보류 중인 다운그레이드를 취소할 수 없습니다. 다시 시도해 주세요.",
  "pricing.cancelPendingDowngradeProcessing": "처리 중...",
  "pricing.scheduled": "예정됨",
  "pricing.processing": "처리 중...",
  "pricing.getMoreReplies": "더 많은 답변 받기",
  "pricing.oneTimeTitle": "계정에 답변 추가하기",
  "pricing.oneTimeAmountLabel": "금액 (USD)",
  "pricing.repliesUnit": "답변",
  "pricing.oneTimeNotice": "구매한 답변 수는 현재 월간 주기 동안에만 유효합니다. 사용하려면 활성 유료 구독이 필요하며 사용하지 않은 답변은 이월되지 않습니다.",
  "pricing.cancel": "취소",
  "pricing.proceed": "계속",
  "pricing.confirmUpgradeTitle": "업그레이드 확인",
  "pricing.confirmDowngradeTitle": "다운그레이드 확인",
  "pricing.confirmUpgradeDesc": "플랜을 업그레이드하려고 합니다. 변경 사항은 즉시 적용되며 비례 청구(또는 크레딧)가 적용될 수 있습니다.",
  "pricing.confirmDowngradeDesc": "다운그레이드를 예약하려고 합니다. 현재 기능은 현재 청구 기간 종료까지 유지됩니다.",
  "pricing.downgradeEffectNote": "다운그레이드는 현재 주기에 대한 환불을 제공하지 않습니다.",
  "pricing.downgradeApplyNextCycle": "새 플랜은 갱신 시 자동으로 시작됩니다.",
  "pricing.confirmCancel": "뒤로",
  "pricing.confirmProceedUpgrade": "지금 업그레이드",
  "pricing.confirmProceedDowngrade": "다운그레이드 예약",

  // FAQ Section
  "faq.title": "자주 묻는 질문",
  "faq.subtitle": "communicate2win에 대해 알아야 할 모든 것",
  "faq.q1": "어떤 커뮤니케이션 시나리오가 지원되나요?",
  "faq.a1": "직장 커뮤니케이션, 개인 관계, 학술 서신, 고객 서비스, 영업 아웃리치 등 다양한 시나리오를 지원합니다. 우리의 AI는 각 상황에 필요한 맥락과 톤에 적응합니다.",
  "faq.q2": "응답 생성 속도는 얼마나 빠른가요?",
  "faq.a2": "우리의 AI는 몇 초 만에 응답을 생성합니다. 품질을 손상시키지 않으면서 속도를 우선시하여 전문적인 응답을 즉시 제공합니다.",
  "faq.q3": "언제든지 구독을 취소할 수 있나요?",
  "faq.a3": "네, 언제든지 구독을 취소할 수 있습니다. 장기 약정이 없으며 필요에 따라 플랜을 다운그레이드하거나 업그레이드할 수 있습니다.",
  "faq.q4": "내 데이터는 안전하고 비공개인가요?",
  "faq.a4": "네, 암호화, 접근 제어, 정기적인 보안 감사를 포함한 포괄적인 보안 조치를 구현하고 있습니다. 입력 콘텐츠와 생성된 응답은 응답 검토 및 템플릿 생성과 같은 기능을 활성화하기 위해 사용자 기록의 일부로 저장됩니다. 계정 설정을 통해 언제든지 기록 데이터를 삭제할 수 있습니다.",
  "faq.q5": "Replies가 다 떨어지면 어떻게 하나요?",
  "faq.a5": "Free 사용자는 다음 월별 사이클까지 할당량이 갱신될 때까지 기다려야 합니다. Pro로 업그레이드한 뒤 Replies가 부족하면 1회성 추가 Replies를 구매할 수 있으며, 추가분은 현재 월간 주기에서만 유효합니다. Enterprise 사용자는 무제한 Replies를 제공합니다.",
  "faq.q6": "어떤 언어가 지원되나요?",
  "faq.a6": "현재 영어를 지원하며 스페인어, 프랑스어, 독일어 및 기타 주요 언어로 확장할 계획입니다. AI는 다국어 커뮤니케이션을 효과적으로 처리할 수 있습니다.",
  
  // Testimonials Section
  "testimonials.title": "커뮤니케이션 쇼케이스",
  "testimonials.subtitle": "공개 메시지, 이메일 및 AI로 다듬어진 응답으로 영감을 얻으세요",
  "testimonials.sarah.name": "사라 존슨",
  "testimonials.sarah.title": "마케팅 디렉터",
  "testimonials.sarah.quote": "communicate2win은 고객 커뮤니케이션 처리 방식을 변화시켰습니다. 응답이 전문적이고 매주 몇 시간을 절약해 줍니다.",
  "testimonials.michael.name": "마이클 첸",
  "testimonials.michael.title": "영업 매니저",
  "testimonials.michael.quote": "직장 시나리오 템플릿이 매우 정확합니다. 이 도구를 사용한 이후 응답률이 40% 향상되었습니다.",
  "testimonials.emily.name": "에밀리 로드리게스",
  "testimonials.emily.title": "고객 성공 리드",
  "testimonials.emily.quote": "어려운 고객 상황을 처리하는 데 완벽합니다. AI가 맥락과 톤을 완벽하게 이해합니다.",
  
  // Interface Elements
  "interface.generating": "응답 생성 중...",
  "interface.generate": "AI 응답 생성",
  "interface.processing": "처리 중...",
  
  // History and Showcase
  "history.shareToShowcase": "쇼케이스에 공유",
  "history.showcased": "쇼케이스됨",
  "history.shareConfirm": "이 게시물을 쇼케이스에 공유하시겠습니까? 게시물을 삭제하지 않는 한 이 작업은 되돌릴 수 없습니다.",
  "history.sharedBy": "공유자:",
  "interface.copy": "복사",
  "interface.share": "공유",
  "interface.shareResponse": "응답 공유",
  "interface.shareNative": "시스템을 통해 공유",
  "interface.shareEmail": "이메일",
  "interface.copyShareText": "링크와 함께 복사",
  "interface.shareTextCopied": "응답과 링크가 클립보드에 복사되었습니다.",
  "interface.ready": "생성 준비 완료",
  "interface.enterMessage": "메시지 내용을 입력하고 시나리오를 선택하여 AI 기반 응답을 시작하세요.",
  "interface.fast": "빠름",
  "interface.accurate": "정확함",
  "interface.professional": "전문적",
  "interface.translation": "번역",
  "interface.responseDescription": "맥락에 맞춘 사려 깊고 전문적인 응답입니다:",
  "interface.multipleOptions": "여러 응답 옵션:",
  "interface.option": "옵션",
  "interface.noContent": "사용 가능한 콘텐츠가 없습니다",
  
  // Placeholders
  "placeholder.message": "답장할 메시지, 이메일 내용 또는 받은 텍스트를 붙여넣으세요...",
  
  // Dropdowns
  "dropdown.useTemplates": "템플릿 사용",
  "dropdown.scenario": "시나리오 없음",
  "dropdown.target": "대상 없음",
  "dropdown.tone": "톤 없음",
  
  // Scenario Options
  "scenario.email": "이메일",
  "scenario.message": "메시지",
  "scenario.workplace": "직장",
  "scenario.school": "학교",
  "scenario.home": "집",
  "scenario.business": "비즈니스",
  "scenario.academic": "학술",
  "scenario.social": "소셜",
  "scenario.formal": "공식",
  "scenario.casual": "캐주얼",
  "scenario.professional": "전문적",
  "scenario.personal": "개인적",
  "scenario.customerService": "고객 서비스",
  "scenario.interview": "면접",
  "scenario.presentation": "프레젠테이션",
  
  // Target Options
  "target.lover": "연인",
  "target.friend": "친구",
  "target.boss": "상사",
  "target.colleague": "동료",
  "target.classmate": "급우",
  "target.parents": "부모님",
  "target.child": "자녀",
  "target.teacher": "선생님",
  "target.student": "학생",
  "target.client": "클라이언트",
  "target.customer": "고객",
  "target.stranger": "낯선 사람",
  "target.family": "가족",
  "target.sibling": "형제자매",
  "target.neighbor": "이웃",
  "target.mentor": "멘토",
  "target.supplier": "공급업체",
  "target.serviceProvider": "서비스 제공업체",
  "target.partner": "파트너",
  "target.subordinate": "부하직원",
  
  // Tone Options
  "tone.humorous": "유머러스",
  "tone.serious": "진지한",
  "tone.happy": "행복한",
  "tone.angry": "화난",
  "tone.mischievous": "장난스러운",
  "tone.polite": "정중한",
  "tone.casual": "캐주얼",
  "tone.formal": "공식적",
  "tone.friendly": "친근한",
  "tone.confident": "자신감 있는",
  "tone.apologetic": "사과하는",
  "tone.enthusiastic": "열정적인",
  
  // Status Messages
  "status.copied": "복사됨!",
  "status.copyDescription": "응답이 클립보드에 복사되었습니다.",
  "status.copyWithTranslationDescription": "응답과 번역이 클립보드에 복사되었습니다.",
  "status.success": "응답이 성공적으로 생성되었습니다.",
  "status.successWithTranslation": "번역과 함께 응답이 생성되었습니다.",
  "status.successWithoutTranslation": "응답이 성공적으로 생성되었습니다.",
  "status.error": "생성 실패",
  "status.errorDescription": "응답 생성에 실패했습니다. 다시 시도해 주세요.",
  "status.enterContent": "콘텐츠를 입력해 주세요",
  "status.enterContentDescription": "답장하고 싶은 메시지를 추가하세요.",
  
  // Pro/Enterprise subscriber restrictions
  "restriction.descriptionOptional": "설명 (선택사항)",
  "restriction.descriptionLabel": "설명 (Pro / Enterprise 구독자만)",
  "restriction.proMaxOnly": "* Pro / Enterprise 구독자만",
  "restriction.desPrompt": "더 나은 응답을 생성하는 데 도움이 되는 상황, 배경 정보 또는 특정 요구사항을 입력하세요...",
  
  // Demo functionality for non-logged-in users
  "demo.title": "답장할 메시지 선택",
  "demo.option1": "영업 오프너 (콜드 아웃리치)",
  "demo.option2": "\"가격이 높다\"는 탐색 처리",
  "demo.option3": "면접 자기소개 (30초 버전)",
  "demo.option4": "이메일 답장",
  "demo.option5": "\"읽었지만 답장 없는\" 잠재고객 후속 조치",
  "demo.option6": "엘리베이터 피치 (30초)",
  "demo.runDemo": "데모 실행",
  "demo.inputContent": "입력 내용:",
  "demo.scenario": "시나리오:",
  "demo.target": "대상:",
  "demo.tone": "톤:",
  "demo.description": "설명:",

  // Showcase Page
  "showcase.title": "커뮤니케이션 쇼케이스",
  "showcase.subtitle": "커뮤니티가 공유한 영감을 주는 AI 기반 커뮤니케이션을 발견하세요",
  "showcase.userPrefix": "다음 사용자의 공개 커뮤니케이션",
  "showcase.backAll": "모든 쇼케이스로 돌아가기",
  "showcase.sortBy": "정렬 기준:",
  "showcase.sort.newest": "최신순",
  "showcase.sort.oldest": "오래된순",
  "showcase.sort.scenario": "시나리오별",
  "showcase.sort.target": "대상별",
  "showcase.sort.tone": "톤별",
  "showcase.filter.scenario": "시나리오:",
  "showcase.filter.target": "대상:",
  "showcase.filter.tone": "톤:",
  "showcase.filter.all": "전체",
  "showcase.loading": "쇼케이스 로딩 중...",
  "showcase.loadingUser": "사용자 커뮤니케이션 로딩 중...",
  "showcase.loadingMore": "추가 로딩 중...",
  "showcase.none.userTitle": "아직 공개 커뮤니케이션이 없습니다",
  "showcase.none.globalTitle": "쇼케이스 항목이 없습니다",
  "showcase.none.userDesc": "이 사용자는 아직 쇼케이스에 커뮤니케이션을 공유하지 않았습니다.",
  "showcase.none.globalDesc": "AI 커뮤니케이션을 쇼케이스에 공유하는 첫 번째 사람이 되어보세요!",
  "showcase.messageDetails": "메시지 상세",
  "showcase.field.date": "날짜",
  "showcase.field.scenario": "시나리오",
  "showcase.field.target": "대상",
  "showcase.field.tone": "톤",
  "showcase.originalMessage": "원본 메시지",
  "showcase.description": "설명",
  "showcase.aiResponse": "AI 응답",

  // Templates
  "templates.saveAsTemplate": "템플릿으로 저장",
  "templates.saved": "템플릿 저장됨",
  "templates.saveSuccess": "템플릿이 성공적으로 저장되었습니다",
  "templates.title": "내 템플릿",
  "templates.new": "새 템플릿",
  "templates.loading": "로딩 중...",
  "templates.none": "템플릿을 찾을 수 없습니다",
  "templates.name": "이름",
  "templates.scenario": "시나리오",
  "templates.target": "대상",
  "templates.tone": "톤",
  "templates.description": "설명",
  "templates.save": "저장",
  "templates.saving": "저장 중...",
  "templates.delete": "템플릿 삭제",
  "templates.deleteConfirm": "이 템플릿을 삭제하시겠습니까?",
  "templates.deleteFailed": "템플릿 삭제에 실패했습니다",
  "templates.nameRequired": "* 템플릿 이름을 입력해 주세요",
  "templates.deleteSuccess": "템플릿이 성공적으로 삭제되었습니다",
  "templates.saveFailed": "템플릿 저장에 실패했습니다",

  // History Modal additions
  "history.messageDetails": "메시지 상세",
  "history.messageDetailsDesc": "원본 입력 및 AI 생성 응답을 포함한 메시지 상세 정보 보기 및 관리.",
  "history.field.date": "날짜",
  "history.field.scenario": "시나리오",
  "history.field.target": "대상",
  "history.field.tone": "톤",
  "history.originalMessage": "원본 메시지",
  "history.aiResponse": "AI 응답",
  "history.description": "설명",
  "history.listTitle": "메시지 기록",
  "history.listDesc": "대화 기록을 탐색, 필터링 및 관리합니다. 메시지를 클릭하여 상세 정보를 확인하세요.",
  "history.sortBy": "정렬 기준:",
  "history.sort.newest": "최신순",
  "history.sort.oldest": "오래된순",
  "history.sort.scenario": "시나리오별",
  "history.sort.target": "대상별",
  "history.sort.tone": "톤별",
  "history.filter.scenario": "시나리오:",
  "history.filter.target": "대상:",
  "history.filter.tone": "톤:",
  "history.filter.all": "전체",
  "history.loading": "기록 로딩 중...",
  "history.loadingMore": "추가 로딩 중...",
  "history.none": "메시지를 찾을 수 없습니다",
  "history.showing": "{total}개 중 {current}개 표시",
  "history.allLoaded": "모든 메시지 로드됨",
  "history.scrollMore": "스크롤하여 더보기",
  "history.loadMoreButton": "더 불러오기",
  "history.deleteMessage": "메시지 삭제",
  "history.deleting": "삭제 중...",
  "history.deleteSuccess": "메시지 기록이 성공적으로 삭제되었습니다",
  "history.deleteFailed": "메시지 기록 삭제에 실패했습니다. 다시 시도해 주세요",
  "history.confirmDeleteTitle": "삭제 확인",
  "history.confirmDeleteSubtitle": "이 작업은 취소할 수 없습니다",
  "history.confirmDeleteDesc": "이 메시지 기록을 삭제하시겠습니까?",
  "history.confirmDeleteAction": "삭제 확인",
  "history.shareTitle": "쇼케이스에 공유",
  "history.shareSubtitle": "이 메시지를 공개하기",
  "history.sharing": "공유 중...",
  "history.confirmShareAction": "공유 확인",
  "history.shareSuccess": "메시지가 쇼케이스에 성공적으로 공유되었습니다",
  "history.shareFailed": "쇼케이스 공유에 실패했습니다. 다시 시도해 주세요",

  // User Menu
  "userMenu.myAccount": "내 계정",
  "userMenu.history": "기록",
  "userMenu.templates": "템플릿",
  "userMenu.signOut": "로그아웃",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "AI 답변 미리보기",
  "hero.preview.scenarioLabel": "시나리오",
  "hero.cta.tryNow": "무료로 시작하기",
  "hero.cta.learnMore": "더 알아보기",
  "hero.cta.getStarted": "무료로 시작하기",
  "hero.preview.primary": "톤 다듬기",
  "hero.preview.secondary": "번역",
  "hero.preview.tone": "친근한",
  "hero.preview.target": "클라이언트",
  "hero.hook": "매일 커뮤니케이션 능력을 향상시키는 수천 명의 사용자와 함께하세요.",
  "hero.headline": "AI 기반 커뮤니케이션 어시스턴트",
  "hero.subheadline": "거친 아이디어를 몇 초 만에 세련되고 상황에 맞는 답변으로 변환합니다.",
  
  // Stats
  "stats.users": "사용자",
  "stats.replies": "답변",
  "stats.languages": "언어",
  
  // Marquee / Logos
  "marquee.trusted": "파트너 / 지원",
  "marquee.aria": "브랜드 로고",
  
  // Interface Elements (additional)
  "interface.advancedOptions": "고급 옵션",
  "interface.clearInput": "입력 지우기",
  "interface.clearDescription": "설명 지우기",
  
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "영업 오프너",
  "demo.shortTitle.priceObjection": "가격 탐색",
  "demo.shortTitle.interviewIntro": "면접 소개",
  "demo.shortTitle.emailReply": "이메일 답장",
  "demo.shortTitle.followUp": "후속 조치",
  "demo.shortTitle.elevatorPitch": "엘리베이터 피치",
  
  // Demo path / response overlay
  "demoTabs.pathPrefix": "demo",
  "demoTabs.response": "response",
  "demoTabs.inputPrompt": "입력 프롬프트",
  "demoTabs.context": "컨텍스트",
  "demoTabs.description": "설명",
  "demoTabs.generate": "생성",
  "demoTabs.aiOutput": "AI 출력",
  "demoTabs.sample": "샘플",
  "demoTabs.streaming": "스트리밍 중...",
  
  // Preview sections
  "preview.section.scenarioTemplates.title": "시나리오 & 템플릿",
  "preview.section.scenarioTemplates.subtitle": "시나리오를 빠르게 선택하거나 저장된 템플릿을 적용합니다. 템플릿은 설명/대상/톤을 미리 채워 고품질 생성을 즉시 시작할 수 있습니다.",
  "preview.section.customInputs.title": "사용자 정의 입력",
  "preview.section.customInputs.subtitle": "핵심 입력 + 선택적 설명 + 고급 시나리오/대상/톤 선택기. 자유롭게 결합하여 상황에 맞는 결과를 얻으세요.",
  "preview.section.cutReplyTime.title": "답변 시간 90% 단축",
  "preview.section.cutReplyTime.subtitle": "수동 작성과 AI 지원 비교. 병렬 옵션 + 내장 번역으로 수정 루프를 줄입니다.",
  "preview.section.copyShare.title": "원클릭 복사 & 공유",
  "preview.section.copyShare.subtitle": "통합된 상단 액션으로 여러 옵션 레이아웃: 모두 복사 / 공유 / 옵션별 복사. 번역이 자동으로 추가됩니다.",
  
  "preview.templates.my": "내 템플릿",
  "preview.templates.new": "새로 만들기",
  "preview.manualFlow": "수동 플로우",
  "preview.aiAssisted": "AI 지원",
  
  // Manual flow bullet steps
  "preview.manualFlow.step1": "구조와 톤 계획",
  "preview.manualFlow.step2": "시작 부분 초안 작성 / 삭제 후 다시 작성",
  "preview.manualFlow.step3": "정중함과 문법 조정",
  "preview.manualFlow.step4": "용어 찾기 및 번역 확인",
  "preview.manualFlow.step5": "대상 앱에 붙여넣기",
  
  "preview.copyAll": "모두 복사",
  "preview.share": "공유",
  "preview.enPlusTranslation": "영어 + 번역",
  "preview.translationAppendNote": "(*) 모두 복사할 때 번역이 자동으로 추가됩니다.",
  "preview.field.scenario": "시나리오",
  "preview.field.target": "대상",
  "preview.field.tone": "톤",
  "preview.auto": "자동",
  "preview.step.pasteOrTemplate": "요청 붙여넣기 또는 템플릿 선택",
  "preview.step.optionalDescription": "(선택사항) 설명/시나리오 추가",
  "preview.step.pickOption": "생성된 옵션 중 하나 선택",
  "preview.step.copyShareTranslate": "원클릭 복사 / 공유 / 번역",
  "preview.time.manual": "5-8분",
  "preview.time.ai": "30-40초",
  
  "testimonials.more": "갤러리를 클릭하여 전체 쇼케이스 탐색"
}